import React, { Component } from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {push, replace} from 'react-router-redux';
import './HomePage.scss';
import { SelectList } from '../../../components';

const mapActionCreators = {
  push,
  replace,
};

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

class Mobile extends Component {

  state = {
    inputText: '',
    selectedChain: undefined
  }


  componentWillMount() {
    let index = this.props.defaultIndex;
    this.setState({ selectedChain: this.props.chainList[index] });
  }
  
  componentDidMount() {
  }
  
  componentWillReceiveProps(newProps){
    if (!this.state.selectedChain && this.props.defaultIndex !== newProps.defaultIndex) {
      let index = newProps.defaultIndex;
      this.setState({selectedChain: newProps.chainList[index]});
    }
  }

  componentWillUnmount(){
  }

  onInputChanged = (e) => {
    let text = e.target.value;
    this.setState({inputText: text});
  }

  onItemSelected = (item) => {
    this.setState({selectedChain: item});
  }

  render = () => {
    const { inputText, selectedChain } = this.state;
    const { chainList, onCommit } = this.props;
    return <div className='home_container_m'>
      <div className='home_logo_m'></div>
      <div className='home_content_m'>
        <div className='home_title_m'>代币信息快速更新</div>
        <div className='home_sub_title_m'>输入具体代币地址并确认，即可快速更新该代币的相关信息</div>
        <div className='home_input_line_m'>
          <SelectList
            value={selectedChain?.name}
            filedName='name'
            list={chainList}
            onItemSelected={this.onItemSelected}
          />
          <input 
            className='home_input_m'
            type='text'
            placeholder='请输入代币合约地址'
            onChange={this.onInputChanged}
            value={inputText}
          />
        </div>
        <div className='home_commit_btn_m' onClick={() => onCommit(selectedChain, inputText)}>申请快速更新</div>
      </div>
    </div>
  }
}


export default connect(mapStateToProps, mapActionCreators)(injectIntl(Mobile));
